import { flow } from 'lodash';

import { NAME } from './configs.constant';

const selectStateKey = (state) => state[NAME];
const selectModeKey = (state) => state.mode;

export const selectState = flow(selectStateKey);
export const selectMode = flow(selectState, selectModeKey);
